import TimesRomanNormal from "../Customfonts/Times-New-Roman.ttf";
import TimesRomanBold from "../Customfonts/Times-New-Roman-Bold.ttf";

export const clienTypes = [
    { label: "Manufacturer (M)", value: 1, short: "M" },
    { label: "Contractor Consignee / End User (C)", value: 2, short: "C" },
    { label: "Supplier (S)", value: 3, short: "S" },
];


// Helper function to convert font file to base64
export async function loadFontAsBase64(fontPath) {
  try {
    const response = await fetch(fontPath);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error loading font:", error);
    return null;
  }
}

// Helper function to add custom fonts to jsPDF
export async function addCustomFonts(doc) {
  try {
    const normalBase64 = await loadFontAsBase64(TimesRomanNormal);
    const boldBase64 = await loadFontAsBase64(TimesRomanBold);
    
    if (normalBase64) {
      doc.addFileToVFS("TimesNewRoman.ttf", normalBase64);
      doc.addFont("TimesNewRoman.ttf", "TimesNewRoman", "normal");
    }
    
    if (boldBase64) {
      doc.addFileToVFS("TimesNewRoman-Bold.ttf", boldBase64);
      doc.addFont("TimesNewRoman-Bold.ttf", "TimesNewRoman", "bold");
    }
  } catch (error) {
    console.error("Error adding custom fonts:", error);
    // Fallback to default font if custom fonts fail
    doc.setFont("helvetica");
  }
}


// FONT LOADER
const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes     = new Uint8Array(buffer);
  const chunkSize = 8192;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
};

export const loadAndAddFont = async (pdfDoc, fontUrl, fontNameTTF, fontName, fontStyle) => {
  const fontResponse = await fetch(fontUrl);
  const fontBuffer   = await fontResponse.arrayBuffer();
  const fontBase64   = arrayBufferToBase64(fontBuffer);
  pdfDoc.addFileToVFS(`${fontNameTTF}.ttf`, fontBase64);
  pdfDoc.addFont(`${fontNameTTF}.ttf`, fontName, fontStyle);
};